import React, { useContext, useEffect } from 'react';
import * as ModalConfig from 'config/componentsCore/modal';
import { CONFIG } from 'config/config';

import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components/macro';
import { GlobalStyle } from 'styles/globalStyle';
import { Button, Layout, Text, View } from '@coinscrap/webapp-core';
import { AgentContext } from '../contexts/agent';

export const MaxWidthMobile = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
`;

export const MainLayout = ({ children }) => {
	const { agent } = useContext(AgentContext);
	useEffect(() => {
		// Necesario para posicionar el header fijo dentro de un transform colocado por el core
		const sidebarContainerComponent = document.querySelector(
			'[corereference="layout-sidebarComponent-sidebarContainerComponent"]',
		);
		const contentContainerComponent = document.querySelector(
			'[corereference="layout-sidebarComponent-contentContainerComponent"]',
		);

		if (contentContainerComponent) {
			contentContainerComponent.style.transform = 'none';
		}

		if (sidebarContainerComponent) {
			sidebarContainerComponent.remove();
		}
	}, []);

	return (
		<Layout
			predefinedLayout={'HeaderFooter'}
			loadingGenerator={(props) => {
				return (
					<Modal open>
						<View loadingModalSt>
							{props?.loadingMessage && (
								<Text
									style={{
										color: CONFIG.colors.primary,
										fontFamily: CONFIG.fonts.semiBold,
										fontSize: '32px',
										margin: '16px',
									}}
								>
									{props?.loadingMessage}
								</Text>
							)}
							<CircularProgress />
						</View>
					</Modal>
				);
			}}
			modalGenerator={(handleClose, children, options) => {
				const mode = options?.mode ? options.mode : 'new';
				const key = options?.key ? options.key : 'modalKey';
				const modalClass = options?.modalClass ? options.modalClass : 'modal-main';
				const showHideCloseButtonClassName = options?.closeButton
					? { visibility: 'visible', marginTop: 10 }
					: { visibility: 'hidden', display: 'none' };

				if (mode === 'new') {
					return (
						<div className={'modal display-flex'} key={key}>
							<section className={modalClass}>
								<ModalConfig.ModalWrapper>
									{children}
									<Button
										style={{
											...showHideCloseButtonClassName,
										}}
										onClick={() => {
											handleClose();
										}}
									>
										Cerrar
									</Button>
								</ModalConfig.ModalWrapper>
							</section>
						</div>
					);
				} else {
					return children;
				}
			}}
			style={{
				sidebarComponent: {
					contentContainerComponent: {
						alignItems: isMobile ? 'flex-start' : 'stretch',
					},
				},
				bodyScrollerComponent: {
					flexGrow: 1,
				},
				bodyComponent: {
					backgroundColor: 'white',
					justifyContent: 'flex-start',
					paddingTop: '0px',
					paddingBottom: '0px',
					overflowY: 'auto',
					minHeight: '100%',
				},
				bodyContentComponent: {
					display: 'flex',
					overflowX: 'hidden',
					justifyContent: 'flex-start',
					maxWidth: '100%',
					overflow: 'auto',
					minHeight:
						isMobile && agent.delioEnabled
							? 'calc(100vh - 200px)'
							: isMobile
							? 'calc(100vh - 148px)'
							: undefined,
				},
			}}
		>
			<MaxWidthMobile>
				<GlobalStyle />
				{children}
				<span id="layoutBottom" />
			</MaxWidthMobile>
		</Layout>
	);
};
